import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import IndustriesHero from './components/IndustriesHero';
import SectorSection from './components/SectorSection';
import DentalCallout from './components/DentalCallout';
import IndustriesCTA from './components/IndustriesCTA';
import IndustriesSEO from './components/IndustriesSEO';
import { industrySectors } from '../../mocks/industries';

export default function IndustriesPage() {
  const location = useLocation();
  const [activeSector, setActiveSector] = useState<string | null>(null);
  const sectionRefs = useRef<Record<string, HTMLElement | null>>({});

  // Scroll to hash on load
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveSector(hash);
      }, 120);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location.hash]);

  // Intersection observer for active sector in nav pills
  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    industrySectors.forEach((sector) => {
      const el = document.getElementById(sector.id);
      if (!el) return;
      sectionRefs.current[sector.id] = el;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActiveSector(sector.id);
        },
        { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
      );
      obs.observe(el);
      observers.push(obs);
    });

    return () => observers.forEach((obs) => obs.disconnect());
  }, []);

  const handleSectorClick = (id: string) => {
    setActiveSector(id);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <IndustriesSEO />
      <Navbar />
      <main className="flex-1">
        <IndustriesHero activeSector={activeSector} onSectorClick={handleSectorClick} />
        {industrySectors.map((sector, idx) => (
          <SectorSection
            key={sector.id}
            sector={sector}
            reverse={idx % 2 !== 0}
          />
        ))}
        <DentalCallout />
        <IndustriesCTA />
      </main>
      <Footer />
    </div>
  );
}
